import React, { Component } from "react";
import ResizeObserver from "resize-observer-polyfill";
import { connect } from "react-redux";
import { ReleaseApi } from "services/release";
import { switchCompany } from "actions/auth";
import { getCompanyInfo, updateUsers } from "actions/company";
import { updateShares } from "actions/storage";
import { Responsive, WidthProvider } from "react-grid-layout";
import { BloxButton } from "styled_components/Common/BloxButton";
import { RESOLUTIONS } from "services/config";
import Joyride from "react-joyride-react-19";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import Block from "sub_components/Home/Block";
import Modal from "sub_components/Common/PortalModalNew";
import { PopUp } from "styled_components/Common/PopUp";
import { Utils } from "services/utils";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { HOME_LAYOUT_GRID } from "utils/Home/HomePageConstants";
import { Permissions } from "services/permissions";
import { SITE_PAGES } from "utils/CommonConstants";
import { setHomeTour } from "actions/tour";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import HomePortalMessage from "sub_components/Home/HomePortalMessage";
import { HomeAccountSwitch } from "sub_components/Home/HomeAccountSwitch";
import AlertBanner from "sub_components/Layout/AlertBanner";
import EulaModal from "sub_components/Common/EulaModal";
import { HtmlModalDisplay } from "styled_components/Common/HtmlModalDisplay";

const CDN_URL = process.env.REACT_APP_CDN_URL;

const defaultUploadCloud = `${CDN_URL}common/upload-icon-default.svg`;

const Account = `${CDN_URL}common/home-account-module-2019.svg`;
const Billing = `${CDN_URL}common/home-billing-module-2019.svg`;
const Support = `${CDN_URL}common/home-support-module-2019.svg`;
const Storage = `${CDN_URL}common/home-storage-module-2019.svg`;
const Colocation = `${CDN_URL}common/home-colocation-module.svg`;

const ResponsiveReactGridLayout = WidthProvider(Responsive);

class Home extends Component {
  constructor(props) {
    super(props);
    this.releaseApi = new ReleaseApi();
    this.myObserver = null;
    this.timeout = null;
    this.state = {
      data: {},
      rowHeight: 0,
      margin: [],
      containerPadding: [],
      layout: [],
      includeDebugGridLines: true,
      breakpoint: RESOLUTIONS.MED,
      modalOpen: false,
      headerText: null,
      customTitle: null,
      startTour: false,
      nextModule: "account",
      updateModal: false,
      latestReleaseNotes: null,
    };
  }

  onMouseOver = (id) => {
    const block = document.getElementById(`blox-clickable-${id}`);
    if (block) {
      block.classList.add("hover");
    }
  };

  companySwitch = (id) => {
    const {
      getCompanyInfo,
      switchCompany,
      navigate,
      updateShares,
      updateUsers,
    } = this.props;
    updateUsers(null);
    updateShares(null);
    getCompanyInfo(id);
    switchCompany(id);
    navigate("/portal/");
  };

  onMouseOut = (id) => {
    const block = document.getElementById(`blox-clickable-${id}`);
    if (block) {
      block.classList.remove("hover");
    }
  };

  repositionWhiteOverlay = () => {
    const horizontalRule = document.querySelector(".gray-horizontal-bar");
    const lowerHalfOverlay = document.querySelector(".lower-half-background");
    const portalHeader = document.querySelector(".portal-header");
    if (lowerHalfOverlay) {
      setTimeout(() => {
        const bottomOfHorizontalRule =
          horizontalRule.getBoundingClientRect().bottom -
          portalHeader.getBoundingClientRect().height;
        lowerHalfOverlay.setAttribute(
          "style",
          `top: ${bottomOfHorizontalRule}px`
        );
      }, 500);
    }
  };
  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };
  setModalContent = (closeModal, customTitle, customFooter) => {
    if (closeModal === "TIMEOUT_CLOSE") {
      this.toggleModal();
      setTimeout(this.closeModal, 3000);
      this.setState({ customTitle, customFooter });
    } else if (closeModal === "CLOSE") {
      this.closeModal();
      this.setState({ customTitle, customFooter });
    } else {
      this.toggleModal();
    }
    if (customTitle === "Ticket Cancelled.") {
      this.setState({ modalOpen: true, customTitle, customFooter });
    } else if (closeModal !== "CLOSE" && closeModal !== "TIMEOUT_CLOSE") {
      this.setState({ customTitle, customFooter });
    }
  };

  onChange = () => {
    let height = window.innerHeight / 56;

    if (window.innerHeight >= 1010 && window.innerHeight <= 1030) {
      height = 18;
    } else if (window.innerHeight >= 1400 && window.innerHeight <= 1500) {
      height = 27;
    }

    if (window.innerHeight <= 660) {
      height = 11;
    }

    this.setState({
      rowHeight: height,
    });

    this.repositionWhiteOverlay();
  };

  onBreakpointChange = () => {
    const margin = [0, 0];
    const containerPadding = [0, 0];

    const horizontalRule = document.querySelector(".gray-horizontal-bar");
    if (horizontalRule) {
      horizontalRule.setAttribute(
        "style",
        `margin-left: ${-containerPadding[0]}px`
      );
    }
    const topNavBar = document.querySelector(".top-nav-bar");
    if (topNavBar) {
      topNavBar.setAttribute("style", `margin-left: ${-containerPadding[0]}px`);
    }

    this.setState({ margin, containerPadding });
  };
  updateScreenBreakpoint = (screenWidth, screenHeight) => {
    let breakpoint = RESOLUTIONS.MED;

    if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
      breakpoint = RESOLUTIONS.LOW;
    } else if (
      screenWidth > RESOLUTIONS.MED &&
      screenWidth <= RESOLUTIONS.HIGH
    ) {
      breakpoint = RESOLUTIONS.MED;
    } else if (screenWidth > RESOLUTIONS.HIGH) {
      breakpoint = RESOLUTIONS.HIGH;
    } else {
      breakpoint = RESOLUTIONS.MIN;
    }
    this.setState({ breakpoint, screenWidth, screenHeight });
  };

  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };

  componentDidMount() {
    const { updateModule, location, setHomeTour } = this.props;
    const nextModule = location?.state?.nextModule;

    updateModule(SITE_PAGES.HOME);
    //addPageToBreadCrumbs(SITE_PAGES.HOME);

    this.onBreakpointChange();
    this.myObserver = new ResizeObserver((entries) => {
      entries.forEach(() => {
        this.onChange();
      });
    });
    this.screenObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const screenWidth = entry.contentRect.width;
        const screenHeight = entry.contentRect.height;
        this.updateScreenBreakpoint(screenWidth, screenHeight);
      });
    });

    const wrapperElement = document.querySelector(".layout");
    this.myObserver.observe(wrapperElement);
    const htmlEl = document.querySelector("html");
    this.screenObserver.observe(htmlEl);

    if (nextModule) {
      this.setState({ nextModule });
      setTimeout(setHomeTour({ runHomeTour: true, action: "start" }), 1000);
    }
    const search = location?.search;

    if (search.includes("upgrade=true")) {
      this.getLatestRelease();
      this.toggleUpdateModal();
    }
  }

  getLatestRelease = () => {
    return this.releaseApi
      .getLatestRelease()
      .then((response) => {
        const { releases } = response.data;

        if (Utils.isValidResponse(response)) {
          this.getReleaseNoteHTML(releases?.[0]?.version);
        }
      })
      .catch((error) => console.log(error));
  };
  getReleaseNoteHTML = async (newVersion) => {
    let version = newVersion;
    try {
      version = version.split(" ").join("");
      let url = CDN_URL.split("cdn");

      url = url[0];
      url = `${url}cdn/release/${version}.html`;
      const response = await this.releaseApi.getReleaseNoteContent(url);
      Utils.isValidResponse(response)
        ? this.setState({ latestReleaseNotes: response.data })
        : this.setState({ error: "Error retrieving content" });
    } catch (e) {
      console.log(e);
      this.setState({ error: "Network error retrieving content" });
    }
  };

  componentWillUnmount() {
    const { setHomeTour } = this.props;
    setHomeTour({ runHomeTour: false, action: "done" });

    try {
      this.myObserver.disconnect();
      clearTimeout(this.timeout);
    } catch (e) {
      console.log(e);
    }
  }
  startTour = () => {
    const { setHomeTour } = this.props;
    setHomeTour({ runHomeTour: true, action: "start" });
  };
  closeTour = (joyride) => {
    const action = joyride?.action;

    if (action === "close" || action === "reset" || action === "stop") {
      const { setHomeTour } = this.props;
      setHomeTour({ runHomeTour: false, action });
    }
  };
  startModuleTour = (moduleOrder) => {
    const { navigate } = this.props;
    const { nextModule } = this.state;
    const url = `/portal/${nextModule}?tour=true`;

    navigate(url, { state: { moduleOrder } });
  };
  getSize = (breakpoint) => {
    let size = "large";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };
  toggleUpdateModal = () => {
    const { updateModal } = this.state;
    this.setState({ updateModal: !updateModal });
  };

  getModuleImage = (module) => {
    switch (module) {
      case "account":
        return Account;
      case "support":
        return Support;
      case "billing":
        return Billing;
      case "storage":
        return Storage;
      case "colocation":
        return Colocation;
      default:
        return Account;
    }
  };

  getModuleBlock = (module) => {
    if (!module) {
      return <Block />;
    } else {
      return (
        <Block
          type="clickable"
          src={this.getModuleImage(module)}
          url={`/portal/${module}`}
          hasAccess={true}
          id={`${module}-block`}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
        />
      );
    }
  };

  getBlock = (modules, position) => {
    const moduleLength = modules.length;

    if (
      (moduleLength === 2 && position === 2) ||
      (moduleLength === 2 && position === 3)
    ) {
      return this.getModuleBlock(modules[position - 2]);
    } else if (moduleLength > 2 || moduleLength === 1) {
      return this.getModuleBlock(modules[position - 1]);
    } else {
      return this.getModuleBlock();
    }
  };

  render() {
    const {
      containerPadding,
      margin,
      rowHeight,
      breakpoint,
      currentModule,
      modalContent,
      modalOpen,
      headerText,
      customTitle,
      customFooter,
      nextModule,
      updateModal,
      latestReleaseNotes,
    } = this.state;
    const {
      auth,
      company_info: { customer: { id } = {} },
      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props;
    const { memberships } = auth;

    const { access: hasBillingAccess } = Permissions.hasService(
      memberships,
      "Billing",
      id
    );
    const { access: hasStorageAccess } = Permissions.hasService(
      memberships,
      "Storage",
      id
    );
    const { access: hasSupportAccess } = Permissions.hasService(
      memberships,
      "Support",
      id
    );
    const { access: hasColoAccess } = Permissions.hasService(
      memberships,
      "Colocation",
      id
    );

    const moduleOrder = [];
    const modules = ["account"];

    if (hasSupportAccess) {
      moduleOrder.push(2);
      modules.push("support");
    }
    if (hasColoAccess) {
      //add colo to tour when ready
      modules.push("colocation");
    }
    if (hasBillingAccess) {
      moduleOrder.push(4);
      modules.push("billing");
    }
    if (hasStorageAccess) {
      moduleOrder.push(1);
      modules.push("storage");
    }

    const steps = {
      account: [
        {
          content:
            "Welcome to the MyDCBLOX (customer portal). Let’s get acquainted!",
          placement: "center",
          target: "body",
          showSkipButton: false,
          disableBeacon: true,
          locale: {
            next: "Begin",
          },
        },
        {
          target: ".account-block",
          content:
            "Here on the home screen, you will find the site modules. Let’s look in the Account module first.",
          customNextButton: (
            <BloxButton
              className="buttons41"
              id="continue-tour"
              text="Next"
              module="support"
              enabled={true}
              onClick={() => this.startModuleTour(moduleOrder)}
              cypressId="continue-tour"
            />
          ),
          showBackButton: false,
          disableBeacon: true,
        },
      ],
      billing: [
        {
          target: ".billing-block",
          content: "Next, Let’s look in the Billing module.",
          customNextButton: (
            <BloxButton
              className="buttons41"
              id="continue-tour"
              text="Next"
              module="support"
              enabled={true}
              onClick={() => this.startModuleTour(moduleOrder)}
              cypressId="continue-tour"
            />
          ),
          showBackButton: false,
          disableBeacon: true,
        },
      ],
      support: [
        {
          target: ".support-block",
          content: "Next, Let’s look in the Support module.",
          customNextButton: (
            <BloxButton
              className="buttons41"
              id="continue-tour"
              text="Next"
              module="support"
              enabled={true}
              onClick={() => this.startModuleTour(moduleOrder)}
              cypressId="continue-tour"
            />
          ),
          showBackButton: false,
          disableBeacon: true,
        },
      ],
      storage: [
        {
          target: ".storage-block",
          content: "Next, Let’s look in the Storage module.",
          customNextButton: (
            <BloxButton
              className="buttons41"
              id="continue-tour"
              text="Next"
              module="support"
              enabled={true}
              onClick={() => this.startModuleTour(moduleOrder)}
              cypressId="continue-tour"
            />
          ),
          showBackButton: false,
          disableBeacon: true,
        },
      ],
    };
    return (
      <>
        <Joyride
          steps={steps[nextModule]}
          continuous={true}
          run={runHomeTour}
          tooltipComponent={JoyRideToolTip}
          scrollToFirstStep={true}
          showProgress={true}
          spotlightPadding={5}
          callback={this.closeTour}
          disableBeacon={true}
          disableOverlayClose={true}
        />
        <div id="home-background" className="home-back-ground">
          <div className="home-page-grid">
            {/* <CrossGrid showGrid /> */}
            <>
              <div className="blocks-container-overlay" />
              <HomePortalMessage />
              <HomeAccountSwitch accountSwitch={this.companySwitch} />
            </>

            <ResponsiveReactGridLayout
              layouts={{
                lg: HOME_LAYOUT_GRID.lg,
                md: HOME_LAYOUT_GRID.md,
                sm: HOME_LAYOUT_GRID.sm,
                xs: HOME_LAYOUT_GRID.xs,
              }}
              className={`layout home-page-layout `}
              rowHeight={rowHeight}
              isDraggable={true}
              isResizable={false}
              breakpoints={{ lg: 2559, md: 1439, sm: 800, xs: 600 }}
              cols={{ lg: 12, md: 12, sm: 12, xs: 12 }}
              containerPadding={containerPadding}
              onBreakpointChange={this.onBreakpointChange}
              margin={margin}
              onLayoutChange={this.onLayoutChange}
              onWidthChange={this.onWidthChange}
            >
              <div key="block-top-filler-0" className="block left">
                <Block />
              </div>
              <div key="block-top-filler-1" className="block">
                <Block />
              </div>
              <div key="block-top-filler-2" className="block">
                <Block />
              </div>
              <div key="block-top-filler-3" className="block">
                <Block />
              </div>
              <div key="block-top-filler-4" className="block">
                <Block />
              </div>
              <div key="block-top-filler-5" className="block">
                <Block />
              </div>
              <div key="block-top-0" className="block top">
                <Block />
              </div>
              <div key="block-top-1" className="block top">
                <Block />
              </div>
              <div key="block-top-2" className="block top">
                <Block />
              </div>
              <div key="block-top-3" className="block top">
                <Block />
              </div>
              <div key="block-top-4" className="block top">
                <Block />
              </div>

              <div key="block-second-0" className="block left">
                <Block />
              </div>
              <div key="block-second-1" className="block">
                <Block />
              </div>
              <div key="block-second-2" className="block">
                <Block />
              </div>
              <div key="block-second-3" className="block">
                <Block />
              </div>
              <div key="block-second-4" className="block">
                <Block />
              </div>
              <div key="block-second-5" className="block">
                <Block />
              </div>

              <div key="block-third-0" className="block ">
                <Block />
              </div>
              <div key="block-third-1" className="block">
                <Block />
              </div>
              <div key="block-third-2" className="block">
                {modules?.length === 5 ? <Block /> : this.getBlock(modules, 1)}
              </div>
              <div key="block-third-3" className="block">
                <Block />
              </div>
              <div key="block-third-4" className="block">
                <Block />
              </div>
              <div key="block-fourth-0" className="block left">
                <Block />
              </div>
              <div key="block-fourth-1" className="block">
                <Block />
              </div>
              <div key="block-fourth-2" className="block">
                {modules?.length === 5
                  ? this.getBlock(modules, 1)
                  : this.getBlock(modules, 2)}
              </div>
              <div key="block-fourth-3" className="block">
                {modules?.length === 5
                  ? this.getBlock(modules, 2)
                  : this.getBlock(modules, 3)}
              </div>
              <div key="block-fourth-4" className="block">
                <Block />
              </div>
              <div key="block-fourth-5" className="block">
                <Block />
              </div>

              <div key="block-fifth-0" className="block ">
                <Block />
              </div>
              <div key="block-fifth-1" className="block">
                {modules?.length === 5 ? this.getBlock(modules, 3) : <Block />}
              </div>
              <div key="block-fifth-2" className="block">
                {this.getBlock(modules, 4)}
              </div>
              <div key="block-fifth-3" className="block">
                {modules?.length === 5 ? this.getBlock(modules, 5) : <Block />}
              </div>
              <div key="block-fifth-4" className="block">
                <Block />
              </div>
              {/* <div key='block-fifth-5' className='block right'>
						<Block />
					</div> */}

              <div key="block-sixth-0" className="block left">
                <Block />
              </div>
              <div key="block-sixth-1" className="block">
                <Block />
              </div>
              <div key="block-sixth-2" className="block">
                <Block />
              </div>
              <div key="block-sixth-3" className="block">
                <Block />
              </div>
              <div key="block-sixth-4" className="block">
                <Block />
              </div>
              <div key="block-sixth-5" className="block">
                <Block />
              </div>

              <div key="block-seventh-0" className="block ">
                <Block />
              </div>
              <div key="block-seventh-1" className="block">
                <Block />
              </div>
              <div key="block-seventh-2" className="block">
                <Block />
              </div>
              <div key="block-seventh-3" className="block">
                <Block />
              </div>
              <div key="block-seventh-4" className="block">
                <Block />
              </div>
              {/* <div key='block-seventh-5' className='block '>
						<Block />
					</div> */}
              <div key="block-eighth-0" className="block left">
                <Block />
              </div>
              <div key="block-eighth-1" className="block">
                <Block />
              </div>
              <div key="block-eighth-2" className="block">
                <Block />
              </div>
              <div key="block-eighth-3" className="block">
                <Block />
              </div>
              <div key="block-eighth-4" className="block">
                <Block />
              </div>

              {/* <div key='test' className='block'>
						<Block />
					</div> */}
            </ResponsiveReactGridLayout>
          </div>
          {!runHomeTour && (
            <div className="portal-alert-banner">
              <AlertBanner orgId={id} breakpoint={breakpoint} />
            </div>
          )}
          <div className="portal-eula-modal">
            <EulaModal
              auth={auth}
              breakpoint={breakpoint}
              setModalContent={this.setModalContent}
              startTour={this.startTour}
            />
          </div>
          {modalOpen && (
            <Modal>
              <PopUp
                showModal={modalOpen}
                closeModal={this.toggleModal}
                customBody={modalContent}
                footer={customFooter}
                title={headerText}
                text={customTitle}
                module={currentModule}
              />
            </Modal>
          )}
        </div>
        <PortraitModalComponent
          closeModal={this.toggleNDAModal}
          show={updateModal}
          header={
            <ModalHeader
              image={defaultUploadCloud}
              text={""}
              className="guest"
            />
          }
          title="We've Upgraded"
          subTitle={"Check out our latest changes."}
          size={this.getSize(breakpoint)}
          breakpoint={breakpoint}
        >
          <HtmlModalDisplay
            id="latest-release"
            cypressId="latest-release"
            html={latestReleaseNotes}
          />
          <ModalFooter
            cypressId="footer"
            id="footer"
            buttonText1="OKAY"
            module="support"
            buttonFunction1={this.toggleUpdateModal}
            size={this.getSize(breakpoint)}
          />
        </PortraitModalComponent>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth_status,
    company_info: state.company_info,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  setHomeTour,
  switchCompany,
  getCompanyInfo,
  updateShares,
  updateUsers,
})(Home);
